import { render, staticRenderFns } from "./factorySparePart.vue?vue&type=template&id=0c887dbc&scoped=true&"
import script from "./factorySparePart.vue?vue&type=script&lang=js&"
export * from "./factorySparePart.vue?vue&type=script&lang=js&"
import style0 from "./factorySparePart.vue?vue&type=style&index=0&id=0c887dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c887dbc",
  null
  
)

export default component.exports